import { marked } from "marked";

import "./MarkedRender.scss";
import MermaidDiagram from "../Mermaid/Mermaid";

export default function MarkedRender({ message }) {
  const renderer = new marked.Renderer();

  const getMarkdown = (input) => {
    if (input) {
      let markdown = marked(input, { sanitize: false, renderer });
      return { __html: markdown };
    }
  };
  const splitContent = (markdown) => {
    const mermaidRegex = /```mermaid([\s\S]*?)```/;
    const match = mermaidRegex.exec(markdown);
    if (match) {
      const beforeMermaid = markdown.slice(0, match.index).trim();
      const mermaidCode = match[1].trim();
      const afterMermaid = markdown.slice(match.index + match[0].length).trim();
      return { beforeMermaid, mermaidCode, afterMermaid };
    }
    return { beforeMermaid: markdown, mermaidCode: null, afterMermaid: "" };
  };

  const { beforeMermaid, mermaidCode, afterMermaid } = splitContent(message);

  return (
    <div className="marked-content">
      {beforeMermaid && (
        <div dangerouslySetInnerHTML={getMarkdown(beforeMermaid)} />
      )}
      {mermaidCode && <MermaidDiagram content={mermaidCode} />}
      {afterMermaid && (
        <div dangerouslySetInnerHTML={getMarkdown(afterMermaid)} />
      )}
    </div>
  );
}
